import { FC, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
// material
import { styled, useTheme } from "@mui/material/styles";
// hooks
import useCollapseDrawer from "../hooks/useCollapseDrawer";
//
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { useAppDispatch } from "../hooks/redux";
import { showProfile } from "../redux/slices/client";
import { getInstances } from "../redux/slices/instances";
import SendWhastsApp from "../components/forms/SendWhastsApp";

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

const MainLayout: FC = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const { collapseClick } = useCollapseDrawer();
  const [open, setOpen] = useState(false);

  // mount logic
  useEffect(() => {
    dispatch(showProfile());
    dispatch(getInstances());
  }, []);

  return (
    <RootStyle>
      <SendWhastsApp />
      <Navbar onOpenSidebar={() => setOpen(true)} />
      <Sidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <MainStyle
        sx={{
          transition: theme.transitions.create("margin", {
            duration: theme.transitions.duration.complex,
          }),
          ...(collapseClick && {
            ml: "102px",
          }),
        }}
      >
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
};

export default MainLayout;
